<template>
  <Modal
    v-bind="$attrs"
    @close="$emit('close')"
    :hasActions="false"
    :fixedTitle="true"
    :title="title"
    fullscreen
    cardTitleClass="primary white--text"
  >
    <template slot="title">
      <div>
        <v-icon
          left
          dark
          @click="$emit('close')"
        >mdi-arrow-left</v-icon>
        {{ title }}
      </div>
      <div>
        <Menu
          :items="menuItems"
          dark
          @imprimir="imprimirOrcamento"
          @pdf="gerarPDF"
          @compartilhar="compartilharOrcamento"
        />
      </div>
    </template>
    <!-- Versão com estilos, não funcinou quando foi pra tela de impressão, ficou cortando -->
    <!-- <div v-if="item" :style="pdfWrapperStyles">
      <h4 class="mb-0">{{ title }}</h4>
      <h4 class="font-weight-medium">{{ item.empresa.razao_social }}</h4>
      <h4 class="font-weight-medium">{{ item.empresa.fantasia }}</h4>
        <div v-if="item && item.empresa && showEmpresaDetails">
          <p class="caption mb-0">
            {{ item.empresa.cnpj }}
            {{ item.empresa.inscricao_estadual ? ` - ${item.empresa.inscricao_estadual}` : '' }}
            {{ item.empresa.inscricao_municipal ? ` - ${item.empresa.inscricao_municipal}` : '' }}
          </p>
          <p class="caption mb-0">
            {{ item.empresa.endereco }}, {{ item.empresa.numero }} - {{ item.empresa.complemento }}
            {{ item.empresa.bairro }} {{ item.empresa.cidade }}, {{ item.empresa.cep }}
          </p>
          <p class="caption mb-0">
            {{ item.empresa.email }}
            {{ item.empresa.site }}
            {{ item.empresa.telefone }}
            {{ item.empresa.fax }}
          </p>
        </div>
      <p class="caption mb-0">
        Emissão: {{ item.data_emissao | dateMonthYear }}
      </p>
      <p class="caption mb-0">
        Válido até: {{ item.validade || new Date() | dateMonthYear }}
      </p>
      <p class="caption mb-0">
        Vendedor: {{ item.vendedor }}
      </p>

      <CardTitle title="Cliente" class="mb-3">
        <v-btn text fab small slot="actions" @click="showClienteDetails = !showClienteDetails">
          <v-icon>{{ iconShowClienteDetails }}</v-icon>
        </v-btn>
        <h4 class="font-weight-medium">{{ item.cliente.razao_social }}</h4>
        <div v-if="item && item.cliente && showClienteDetails">
          <p class="caption mb-0">
            {{ item.cliente.cpf_cnpj }} 
            {{ item.cliente.rg_ie ? ` - ${item.cliente.rg_ie}` : '' }}
          </p>
          <p v-if="item.cliente.enderecos && !!item.cliente.enderecos[0]" class="caption mb-0">
            {{ item.cliente.enderecos[0].logradouro }}, {{ item.cliente.enderecos[0].numero }} - {{ item.cliente.enderecos[0].complemento }}
            {{ item.cliente.enderecos[0].ponto_referencia }} {{ item.cliente.enderecos[0].bairro }} {{ item.cliente.enderecos[0].cidade }},
            {{ item.cliente.enderecos[0].cep }}
          </p>
          <p v-if="item.cliente.telefones" class="caption mb-0">
            {{ item.cliente.telefones.join(',') }}
          </p>
        </div>
      </CardTitle>

      <CardTitle :title="`Itens (${item.itens.length})`" class="my-3">
        <div v-for="(produto, index) in item.itens" :key="index">
          <p class="font-weight-bold mb-0">{{ produto.id_produto }} - {{ produto.descricao }}</p>
          <p class="mb-0 caption">
            {{ produto.qtde_produto }} {{ produto.unidade }} x {{ produto.preco_bruto | price }} - <span class="red--text">{{ produto.desconto | price }}</span> = {{ produto.subtotal | price }}
          </p>
          <v-divider class="my-1"></v-divider>
        </div>
        <div class="text-right">
          <span>SubTotal: {{ item.total_bruto | price }}</span><br>
          <span class="red--text">Desconto: {{ item.total_desconto | price }}</span><br>
          <span class="font-weight-bold">Total: {{ item.total_produto | price }}</span>
        </div>
      </CardTitle>

      <CardTitle title="Forma de pagamento" class="my-3">
        <div v-for="(parcela, index) in item.parcelas" :key="index">
          <p class="mb-0">
            <span class="pr-3">{{ parcela.tipo_documento }}</span>
            <span class="pr-3">{{ parcela.data_vencimento | dateMonthYear }}</span>
            <span class="pr-3">{{ parcela.valor_parcela | price }}</span>
          </p>
          <v-divider class="my-1"></v-divider>
        </div>
      </CardTitle>

      <CardTitle title="Observações" v-if="item.observacoes">
        {{ item.observacoes }}
      </CardTitle>
    </div> -->
    <!-- Versão utilizando table, funcionou melhor -->
    <div v-if="item" id="pdfwrapper">
      <table cellpadding="0" cellspacing="0" border="0" align="left" width="100%">
        <tr>
          <td>
            <table cellpadding="0" cellspacing="0" border="0" align="left" width="600" class="width100">
              <tr>
                <td>
                  <table cellpadding="0" cellspacing="0" border="0" align="left" width="600" class="width100">
                    <tr>
                      <td>
                        <!-- Header Table -->
                        <table cellpadding="0" cellspacing="0" border="0" align="left" width="600" class="width100">
                          <tr>
                            <td>
                              <!-- Compnay Table -->
                              <table
                                v-if="item.empresa"
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                align="left"
                                width="600"
                                class="width100"
                              >
                                <tr>
                                  <td style="font-family: 'Open Sans', sans-serif;">
                                    <span><strong>{{ item.empresa.razao_social }}</strong></span> <br>
                                    <span><strong>{{ item.empresa.nome_fantasia }}</strong></span> <br>
                                    <span>{{ item.empresa.cpf_cnpj }} {{ item.empresa.inscricao_estadual && `- ${item.empresa.inscricao_estadual}` }}</span> <br>
                                    <span>{{ item.empresa.endereco }}, {{ item.empresa.numero_endereco }} - {{ item.empresa.complemento }}
            {{ item.empresa.bairro }} {{ item.empresa.cidade }}, {{ item.empresa.cep }}</span><br>
                                    <span>Tel.: {{ item.empresa.telefone }} {{ item.empresa.fax }}</span><br>
                                    <span>E-mail: {{ item.empresa.email }} {{ item.empresa.site }}</span>
                                  </td>
                                </tr>
                                <tr><td height="20"></td></tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                        <!-- Orçamento Table -->
                        <table cellpadding="0" cellspacing="0" border="0" align="center" width="600" class="width100" style="text-align: center;">
                          <tr>
                            <td style="font-family: 'Open Sans', sans-serif;">
                              <h3><strong>ORÇAMENTO</strong></h3>
                            </td>
                          </tr>
                        </table>
                        <table cellpadding="5" cellspacing="0" border="1" align="center" width="600" class="width100">
                          <tr style="font-family: 'Open Sans', sans-serif;">
                            <td>
                              <span><strong>Criado em</strong></span><br>
                              <span>{{ item.data_emissao | dateMonthYear }}</span>
                            </td>
                            <td>
                              <span><strong>Válido até</strong></span><br>
                              <span>{{ item.data_validade || new Date() | dateMonthYear }}</span>
                            </td>
                            <td>
                              <span><strong>Orçamento</strong></span><br>
                              <span>{{ item.id_interno }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2">
                              <span><strong>Cliente:</strong></span><br>
                              <span v-if="item.cliente">{{ item.cliente.razao_social }}</span>
                            </td>
                            <td>
                              <span><strong>Vendedor:</strong></span><br>
                              <span>{{ item.vendedor }}</span>
                            </td>
                          </tr>
                        </table>
                        <!-- Spacing Table -->
                        <table cellpadding="0" cellspacing="0" border="0" align="center" width="600" class="width100">
                          <tr><td height="40"></td></tr>
                        </table>
                        <!-- Produtos Table -->
                        <table cellpadding="5" cellspacing="0" border="1" align="left" width="600" class="width100">
                          <tr align="left" style="font-family: 'Open Sans', sans-serif;">
                            <th bgcolor="#ccc">Cód.</th>
                            <th bgcolor="#ccc">Produto</th>
                            <th bgcolor="#ccc">Und</th>
                            <th bgcolor="#ccc">QTD</th>
                            <th bgcolor="#ccc">Preço</th>
                            <th bgcolor="#ccc">SubTotal</th>
                          </tr>
                          <tr v-for="(produto, index) in item.itens" :key="index" style="font-family: 'Open Sans', sans-serif;">
                            <td>{{ produto.id_produto }}</td>
                            <td>{{ produto.descricao }}</td>
                            <td>{{ produto.unidade }}</td>
                            <td>{{ produto.qtde_produto }}</td>
                            <td>{{ produto.preco_bruto | price }}</td>
                            <td>{{ produto.subtotal_bruto | price }}</td>
                          </tr>
                          <tr style="font-family: 'Open Sans', sans-serif;">
                            <td colspan="4"></td>
                            <td style="color: red;"><strong>Desconto</strong></td>
                            <td style="color: red;"><strong>{{ item.total_desconto | price }}</strong></td>
                          </tr>
                          <tr style="font-family: 'Open Sans', sans-serif;">
                            <td colspan="4"></td>
                            <td><strong>Total</strong></td>
                            <td><strong>{{ item.total_produto | price }}</strong></td>
                          </tr>
                        </table>
    
                        <!-- Spacing Table -->
                        <table cellpadding="0" cellspacing="0" border="0" align="center" width="600" class="width100">
                          <tr><td height="40"></td></tr>
                        </table>

                        <!-- Parcelas Table -->
                        <table cellpadding="5" cellspacing="0" border="1" align="left" width="600" class="width100">
                          <tr align="left" style="font-family: 'Open Sans', sans-serif;">
                            <th bgcolor="#ccc">Forma de pagamento</th>
                          </tr>
                          <tr v-if="item.parcelas">
                            <td style="font-family: 'Open Sans', sans-serif;">
                              <div v-for="(parcela, index) in item.parcelas" :key="index">
                                <p class="mb-0">
                                  <span class="pr-3">{{ parcela.tipo_documento }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                  <span class="pr-3">{{ parcela.data_vencimento | dateMonthYear }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                  <span class="pr-3">{{ parcela.valor_parcela | price }}</span>
                                </p>
                              </div>
                            </td>
                          </tr>
                        </table>

                        <!-- Spacing Table -->
                        <table cellpadding="0" cellspacing="0" border="0" align="center" width="600" class="width100">
                          <tr><td height="40"></td></tr>
                        </table>
                        
                        <!-- Observações Table -->
                        <table cellpadding="5" cellspacing="0" border="1" align="left" width="600" class="width100">
                          <tr align="left" style="font-family: 'Open Sans', sans-serif;">
                            <th bgcolor="#ccc">Observações</th>
                          </tr>
                          <tr v-if="item.observacoes">
                            <td style="font-family: 'Open Sans', sans-serif;">
                              <span>{{ item.observacoes }}</span>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
    <div v-else class="text-center font-weight-bold">
      Nenhum registro encontrado
    </div>
  </Modal>
</template>

<script>
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import printJS from 'print-js';

export default {
  name: 'ModalCompartilharOrcamento',
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  components: {
    Modal: () => import('@/components/shared/Modal'),
    Menu: () => import('@/components/shared/Menu'),
    // CardTitle: () => import('@/components/shared/CardTitle')
  },
  data: () => ({
    showEmpresaDetails: true,
    showClienteDetails: true,
    isGeneratingPDF: false,
    menuItems: [
      { title: 'Imprimir', value: 'imprimir' },
      // { title: 'Gerar PDF', value: 'pdf' },
      // { title: 'Compartilhar', value: 'compartilhar' },
    ]
  }),
  computed: {
    title() {
      return this.item ? this.item.title : 'Compartilhar';
    },
    pdfWrapperStyles() {
      return this.isGeneratingPDF && this.$vuetify.breakpoint.smAndUp ? { width: '595px' } : {};
    },
    iconShowEmpresaDetails() {
      return this.showEmpresaDetails ? 'mdi-chevron-up' : 'mdi-chevron-down';
    },
    iconShowClienteDetails() {
      return this.showClienteDetails ? 'mdi-chevron-up' : 'mdi-chevron-down';
    }
  },
  methods: {
    imprimirOrcamento() {
      // setTimeout(() => window.print(), 100);
      setTimeout(() => {
        printJS({
          printable: 'pdfwrapper',
          type: 'html',
          style: '.width100 { width: 595px !important; border: none; }'
        });
      }, 100);
    },
    gerarPDF() {
      this.isGeneratingPDF = true;
      const el = document.querySelector('#pdfwrapper');
      // const { clientWidth, clientHeight } = el;

      this.$nextTick(() => {
        html2canvas(el, {
          imageTimeout: 5000,
          useCORS: true,
        })
        .then(canvas => {
          const img = canvas.toDataURL('image/png');
          const pdf = new jsPDF();

          pdf.addImage(img, 'JPEG', 5, 5);
          pdf.save('test.pdf');
          this.isGeneratingPDF = false;
        });
      });
    },
    compartilharOrcamento() {
      if (navigator.share) {
        navigator.share({
          title: 'Syclus Peddidos - Orçamento #4',
          text: 'Testando API de compartilhamento do Browser',
          url: 'https://pedido.syclus.com.br'
        })
        .then(() => console.log('Obrigado por compartilhar')
        .catch(console.error));
      } else {
        console.log('Não há suporte para o compartilhamento');
      }
    }
  }
}
</script>

<style scoped>
@page {
  margin: 0 !important;
}

@media print {
  .width100 {
    width: 595px !important;
  }
}

@media only screen and (max-width: 600px) {
  .width100 {
    width: 100%;
  }
}
</style>